import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SchoolHeader from "../components/SchoolHeader";
import StudentHeader from "../components/StudentHeader";
import HospitalHeader from "../components/HospitalHeader";
import { Container, Breadcrumb, Accordion, Row, Col } from "react-bootstrap";

const Faq = () => {
    const BaseURL = process.env.REACT_APP_BASE_URL
    const title = localStorage.getItem("PageTittle")
    const token = localStorage.getItem("token")
    const [faq, setFaq] = useState()
    useEffect(() => {
        try {
            axios.get(`${BaseURL}users/getFaq`).then(res => setFaq(res.data.data))

        } catch (error) {
            console.log(error)

        }
    }, [])
    console.log(faq)

    return (
        <div className="faq_respnve">
            {title === "School" && token && <SchoolHeader />}
            {title === "Hospital" && token && <HospitalHeader />}
            {title === "Student" && token && <StudentHeader />}
            {!token && <Header />}
            <section className="bnner_imgswork py-5">
                <div className="cntctbnnr_img text-center">
                    <h1>FAQs</h1>
                    <div className="innner_hmm text-center">
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                            <Breadcrumb.Item active>FAQs</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </section>
            <div className="prvcy_policy">
                <Container className="set_wdt_fqs">
                    <Row>
                        <Col md={5}>
                            <div className="tstmnl_hdng">
                                <h6 className="text_theme">Support</h6>
                                <h2>Frequently Asked Questions </h2>
                                <p>Everything you need to know about us.</p>
                            </div>
                        </Col>
                        <Col md={7}>
                            <div className="faq_div">
                                <Accordion
                                    defaultActiveKey="0"
                                    flush
                                    className="doc_accrdn"
                                >
                                    {faq && faq.map((res, index) => {
                                        return (
                                            <Accordion.Item eventKey={index}>
                                                <Accordion.Header sName="quesn_wrap">
                                                    {res?.question}
                                                </Accordion.Header>
                                                <Accordion.Body className="acc_wrap">
                                                    {res?.answer}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default Faq;
